module.exports = __webpack_public_path__ + "static/media/traffic-planned.5f4bf657.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/traffic-planned.svg
// module id = 761
// module chunks = 0